<template>
  <div class="tab-bar">
    <router-link to="/workbench" class="tab-item" active-class="active">
      <div class="tab-icon">
        <img
          :src="activeTab === 'workbench' ? bar2 : bar1"
          alt="工作台"
          class="tab-img"
        />
      </div>
      <div class="tab-text">工作台</div>
    </router-link>

    <router-link
      to="/customer"
      class="tab-item"
      active-class="active"
      @click.native="handleSpecialClick"
    >
      <div class="tab-icon">
        <img
          :src="activeTab === 'customer' ? bar3 : bar4"
          alt="客户"
          class="tab-img"
        />
      </div>
      <div class="tab-text">客户</div>
    </router-link>

    <!-- <router-link to="/live" class="tab-item" active-class="active">
      <div class="tab-icon">
          <img :src="activeTab === 'live' ? bar6 : bar5" alt="直播" class="tab-img">
      </div>
      <div class="tab-text">直播</div>
    </router-link> -->
    <!-- <router-link to="/myindex" class="tab-item" active-class="active">
      <div class="tab-icon">
          <img :src="activeTab === 'myindex' ? bar8 : bar7" alt="我的" class="tab-img">
      </div>
      <div class="tab-text">我的</div>
    </router-link> -->
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import bar1 from "@/assets/img/tabbar/bar-1.png";
import bar2 from "@/assets/img/tabbar/bar-1-1.png";
import bar3 from "@/assets/img/tabbar/bar-2-2.png";
import bar4 from "@/assets/img/tabbar/bar-2.png";
import bar5 from "@/assets/img/tabbar/bar-3.png";
import bar6 from "@/assets/img/tabbar/bar-3-3.png";
import bar7 from "@/assets/img/tabbar/bar-4.png";
import bar8 from "@/assets/img/tabbar/bar-4-4.png";

const activeTab = ref("workbench");
const route = useRoute();
const router = useRouter();

const updateActiveTab = () => {
  const path = route.path;
  if (path.includes("/workbench")) {
    activeTab.value = "workbench";
  } else if (path.includes("/customer")) {
    activeTab.value = "customer";
  } else if (path.includes("/live")) {
    activeTab.value = "live";
  } else if (path.includes("/myindex")) {
    activeTab.value = "myindex";
  }
};

onMounted(() => {
  updateActiveTab();
});

function handleSpecialClick(event) {
  // 1. 阻止 router-link 自动跳转
  event.preventDefault();
  //   console.log("执行方法...");

  // 2. 你的逻辑...
  localStorage.removeItem("needShowCustomerBadge");
  localStorage.removeItem("workbenchCustomerNum");

  // 3. 逻辑执行完后，手动跳转
  router.push("/customer");
}

// 监听路由变化
watch(
  () => route.path,
  () => {
    updateActiveTab();
  },
);
</script>

<style lang="less" scoped>
.tab-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 70px;
  background-color: #fff;
  border-top: 1px solid #f6f6f6;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-bottom: env(safe-area-inset-bottom, 0); // 适配刘海屏
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.tab-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.tab-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tab-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.tab-text {
  font-size: 11px;
  line-height: 15px;
  color: #5f4b2d;
  font-weight: 500;
}

.tab-item.active .tab-text {
  background: linear-gradient(135deg, #ff7123, #ffb45b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}
</style>
